import { UnreadMessagesCardImpl } from '@fiverr-private/jtbd_card_unread_messages';
import { BusinessInfoCardImpl } from '@fiverr-private/jtbd_card_business_info';
import { JobsTBDTypes } from '@fiverr-private/homepage_common_types';
import { JobsTbdSdk, DrawerSDK, ModalSDK } from '@fiverr-private/jtbd_sdk';
import { OrderUpdatesCardImpl } from '@fiverr-private/jtbd_card_order_updates';
import { ProMigrationCardImpl } from '@fiverr-private/jtbd_card_pro_migration';
import { ShareYourExperienceCardImpl } from '@fiverr-private/jtbd_card_share_your_experience';
import { DynamicMatchingCardImpl } from '@fiverr-private/jtbd_card_dynamic_matching';
import { StoreBuilderCardImpl } from '@fiverr-private/jtbd_card_store_builder';
import { BookPublishingProjectCardImpl } from '@fiverr-private/jtbd_card_book_publishing_project';
import { TitleBadge } from '@fiverr-private/jtbd_sdk/src/types/card_sdk';
import { BetaBadge } from '@fiverr-private/badges';
import { ProjectManagementCardImpl } from '@fiverr-private/jtbd_card_project_management';
import { DownloadAppModalImpl, DownloadAppCardImpl } from '@fiverr-private/jtbd_card_download_app';
import { SourcingCard } from '@fiverr-private/jtbd_card_sourcing';

export const JobsTbdMapper: Record<JobsTBDTypes, JobsTbdSdk> = {
    business_info: BusinessInfoCardImpl,
    unread_messages: UnreadMessagesCardImpl,
    order_updates: OrderUpdatesCardImpl,
    pro_migration: ProMigrationCardImpl,
    share_your_experience: ShareYourExperienceCardImpl,
    dynamic_matching: DynamicMatchingCardImpl,
    project_management: ProjectManagementCardImpl,
    download_app: DownloadAppCardImpl,
    store_builder: StoreBuilderCardImpl,
    book_publishing_project: BookPublishingProjectCardImpl,
    sourcing: SourcingCard,
};

export const JobsTbdDrawerMapper: Partial<Record<JobsTBDTypes, DrawerSDK>> = {};

export const JobsTbdModalMapper: Partial<Record<JobsTBDTypes, ModalSDK>> = {
    download_app: DownloadAppModalImpl,
};

export const JobsTbdTitleBadgeMapper: Record<TitleBadge, typeof BetaBadge> = {
    beta: BetaBadge,
};
